import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'bra-password',
  templateUrl: './bra-password.component.html',
  styleUrls: ['./bra-password.component.css']
})
export class BraPasswordComponent implements OnInit {
  form: FormGroup;
  public hide = true;

  @Input()
  name: string;

  @Input()
  placeholder: string;

  @Input() value: any;

  @Input()
  readonly: boolean;

  @Input()
  messageError: string;

  @Input()
  maxlength: number;

  @Input()
  autofocus: boolean;

  @Input()
  disabled: boolean;

  @Output() valueChange = new EventEmitter();

  @Output() focused = new EventEmitter();

  constructor( private fb: FormBuilder) {
    this.form = this.fb.group({
      password: ['']
    });
   }

   get password(){
    return this.form.get('password');
   }

  ngOnInit() {
  }

  onPasswordInput(event: Event):
  void{
    const input = (event.target as HTMLInputElement).value;
    this.valueChange.emit(input);
  }

  changeFocus(focused: boolean) {
    this.focused.emit(focused);
  }
}



// WEBPACK FOOTER //
// /home/runner/_work/fini-sta-01-estatico-sitecliente/fini-sta-01-estatico-sitecliente/src/app/componentes/bra-password/bra-password.component.ts